import { EventEmitter } from '@angular/core';
import { Params } from '@angular/router';
import { ValueTypes } from '../common/custom.types';
import { CardInfoType } from '../components/profile/profile.enum';
import { AccountStatus, UserRelationToGroup } from '../swagger-api';
import { MaybeNull } from '../utils';

export interface EntityCreator {
  userId: string;
  displayName: string;
  accountStatus: AccountStatus;
}

export interface CardDate {
  date: string;
  dateFormat: string;
}

export interface CardModel {
  id: string;
  header: string;
  title: string;
  buttonHint: string;
  status: EntityStatus;
  buttonRouterLink: string;
  buttonRouterParams?: object;
  badge?: UserRelationToGroup;
  description: ValueTypes;
  descriptionType: CardInfoType;
  created: CardDate;
  actionBtnHint: string;
  image: string;
  actionBtnId: string;
  entityCreator?: EntityCreator;
  urlFragment?: string;
  actionDisabled: boolean;
}

export interface CardContent {
  card: CardModel;
  index: number;
  action?: EventEmitter<string>;
  status?: EntityStatus;
}

export interface CardContentWithBtnInfo {
  card: CardModel;
  index: number;
  action: EventEmitter<ActionBtnInfo>;
  status: EntityStatus;
  actionDisabled: boolean;
}

export interface ActionBtnInfo {
  actionBtnId: string;
  dataTestId?: string;
}

export interface EyePasswordTextings {
  dataTestId: string;
  text: string;
}

export interface CreateItemData<T> {
  project_id?: Partial<T>;
  community_id?: Partial<T>;
}

export interface CreateItemInfo<T> {
  data?: CreateItemData<T>;
  returnUrl?: string;
  createLink: string;
  createItemTitle: string;
}

export interface ItemsListContent<T> {
  createItemInfo?: CreateItemInfo<T>;
}

export enum ItemStatus {
  EMPTY = '',
  EXPIRED = 'PROJECT_EXPIRED',
  PRIVATE = 'PRIVATE',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
  DEACTIVATED = 'DEACTIVATED',
}

export type EntityStatus = AccountStatus | ItemStatus;

export interface UICard {
  id: string;
  title: string;
  subtitle: string;
  content: string;
  link: MaybeNull<Link>;
  avatar: MaybeNull<Avatar>;
  button: MaybeNull<Button>;
  headerBadge: MaybeNull<Badge>;
  contentBadge: MaybeNull<Badge>;
}

export interface Badge {
  text: string;
  style: string;
}

export interface Avatar {
  link: Link;
  image: string;
  status: string;
}

export interface Link {
  href: string;
  text: string;
  isActive: boolean;
  fragment?: string;
  queryParams?: Params;
}

export interface Button {
  text: string;
  isDisabled: boolean;
  onClick: () => void;
}
